import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["accept", "multiple"]

import { ref } from "vue";

import ButtonBase from "@/components/button/ButtonBase.vue";

import { InputFileProps } from "@/types/props";


export default /*@__PURE__*/_defineComponent({
  __name: 'InputFile',
  props: {
    accept: {},
    disabled: { type: Boolean },
    multiple: { type: Boolean }
  },
  emits: ["change"],
  setup(__props: any) {

const props = __props


const fileInput = ref();

const getEvent = (files: File[]): File | File[] | undefined => {
    if (!files) return;
    return props.multiple ? files : files[0]
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("input", {
      ref_key: "fileInput",
      ref: fileInput,
      type: "file",
      accept: props.accept,
      multiple: props.multiple,
      onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('change', getEvent($event.target?.files))))
    }, null, 40, _hoisted_1), [
      [_vShow, false]
    ]),
    _createVNode(ButtonBase, {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (fileInput.value.click())),
      disabled: __props.disabled
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default", {}, () => [
          _createTextVNode(_toDisplayString(_ctx.$t('button.search')), 1)
        ])
      ]),
      _: 3
    }, 8, ["disabled"])
  ], 64))
}
}

})